<script>
  import uamsLogoSvg from '$lib/assets/img/uams-logo_main_dark.svg';
  import uamsLogoImg from '$lib/assets/img/uams-logo_main_dark_189x50.png';
  import { FontAwesomeIcon } from '@fortawesome/svelte-fontawesome';
  import { faUser } from '@itdev-fortawesome/pro-solid-svg-icons/faUser';
  import { auth } from '$lib/stores/auth.svelte.js';
  import { faUserGroup } from '@itdev-fortawesome/pro-solid-svg-icons/faUserGroup';
  import { faBars } from '@itdev-fortawesome/pro-regular-svg-icons/faBars';
</script>

<a href="#main-content" class="skip-link">Skip to main content</a>
{#if auth.user?.impersonatorId !== undefined}
  <div class="bg-info-subtle border-bottom border-info-subtle text-center small p-2">
    <FontAwesomeIcon icon={faUserGroup} size="sm" /> <span class="visually-hidden">Impersonating </span>
    {auth.user.name}
    <a
      role="button"
      class="px-2"
      href="/"
      onclick={e => {
        e.preventDefault();
        auth.stopAuthImpersonation();
      }}>Stop Impersonation</a
    >
  </div>
{/if}
<header class="site-header navbar navbar-expand-md">
  <div class="global-title">
    <a class="navbar-brand" href="https://www.uams.edu">
      <picture>
        <source srcset={uamsLogoSvg} media="(min-width: 1px)" />
        <img src={uamsLogoImg} alt="University of Arkansas for Medical Sciences Logo" />
      </picture>
    </a>
    <div class="navbar-subbrand">
      <a class="title" title="Clinical Skills Leaderboards" href="/">Clinical Skills Leaderboards</a>
    </div>
  </div>
  <!-- End global-title -->
  <nav>
    <ul class="nav nav-pills">
      <li class="nav-item"></li>
      {#if auth.environment !== null && auth.environment !== 'Production'}
        <li class="nav-item">
          <span class="nav-link active">{auth.environment.substring(0, 3).toUpperCase()}</span>
        </li>
      {/if}
      {#if auth.user}
        <li class="nav-item">
          <a href="/saml/logout" class="nav-link">Log out</a>
        </li>
      {:else if !auth.loading}
        <li class="nav-item">
          <a href="/saml/login" class="nav-link"><FontAwesomeIcon icon={faUser} class="me-2" />Log in</a>
        </li>
      {/if}
      {#if auth.user !== null && auth.user.role !== 'student'}
        <li class="app-navigation-drawer">
          <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasNavbar"
            aria-controls="offcanvasNavbar"
            aria-label="Toggle navigation"
          >
            <FontAwesomeIcon icon={faBars} class="mt-1" />
          </button>
        </li>
      {/if}
    </ul>
  </nav>
</header>

<style>
  .site-header {
    padding: 24.144px 2rem;
    align-items: flex-start;
  }

  .global-title {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-right: auto;
    gap: 22.3332px;
  }

  .global-title .navbar-brand {
    --bs-navbar-brand-padding-y: 0;
  }

  .global-title .navbar-brand img {
    height: 31.8912px;
  }
  .global-title .navbar-subbrand .title {
    font-size: 19.13472px;
    line-height: 1.2;
    color: inherit;
    display: block;
  }

  .site-header nav {
    position: absolute;
    right: 1rem;
  }

  .site-header .nav {
    --bs-nav-link-color: var(--bs-body-color);
  }

  .app-navigation-drawer {
    --bs-navbar-toggler-padding-y: 0.25rem;
    --bs-navbar-toggler-padding-x: 0.25rem;
    --bs-navbar-toggler-font-size: 20px;
    --bs-navbar-border-width: 1px;
    --bs-navbar-color: black;
    --bs-navbar-toggler-border-color: transparent;
    padding-top: 1px;
    --bs-navbar-toggler-focus-width: 1px;
    /*display: flex;
    align-items: baseline;*/
  }

  @media (min-width: 576px) {
    .global-title .navbar-brand img {
      height: 31.8912px;
    }
  }

  @media (min-width: 768px) {
    .global-title .navbar-brand img {
      height: 37px;
    }

    .site-header {
      padding: 30.18px 2rem;
    }

    .global-title .navbar-subbrand .title {
      padding: 0;
      font-size: 25.9px;
    }
  }

  @media (min-width: 1200px) {
    .site-header {
      align-items: center;
    }

    .global-title {
      flex-direction: row;
      gap: 0;
    }

    .global-title .navbar-brand {
      padding: 0 22.3332px 0 0;
      margin: 0;
      border-right: 2px solid var(--uams-primary-red);
    }

    .global-title .navbar-subbrand {
      padding: 0 0 0 22.3332px;
      margin: 0;
    }

    .global-title .navbar-subbrand .title {
      padding: 2.96px 0;
    }
  }

  @media (min-width: 1500px) {
    .global-title .navbar-brand img {
      height: 50px;
    }

    .global-title .navbar-subbrand .title {
      font-size: 35px;
    }
  }

  .skip-link {
    position: absolute;
    top: -100%; /* Hidden off-screen by default */
    left: 1rem;
    background-color: white;
    color: black;
    border-style: solid;
    border-color: black;
    border-width: 0 1px 1px 1px;
    border-bottom-right-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
    padding: 1rem 2rem;
    text-decoration: none;
    font-weight: bold;
    z-index: 1000; /* Ensure it appears above other content */
  }

  .skip-link:focus {
    top: 0; /* Move to the top of the screen when focused */
  }
</style>
